import { Routes, Route, Navigate } from 'react-router-dom';
import { useLenis } from '@/hooks/useLenis';
import { Nav } from '@/components/Nav';
import { Footer } from '@/components/Footer';
import { ScrollToTop } from '@/components/ScrollToTop';
import Home from '@/pages/Home';
import ManifestoPage from '@/pages/Manifesto';
import ProdottoPage from '@/pages/Prodotto';
import ClientiPage from '@/pages/Clienti';
import TeamPage from '@/pages/Team';
import ChiSiamoPage from '@/pages/ChiSiamo';
import CandidaturePage from '@/pages/Candidature';
import FunzionalitaPage from '@/pages/Funzionalita';

export default function App() {
  useLenis();

  return (
    <div className="grain min-h-dvh">
      <ScrollToTop />
      <Nav />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/manifesto" element={<ManifestoPage />} />
          <Route path="/prodotto" element={<ProdottoPage />} />
          <Route path="/funzionalita/:slug" element={<FunzionalitaPage />} />
          <Route path="/clienti" element={<ClientiPage />} />
          <Route path="/prezzi" element={<Navigate to="/" replace />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/chi-siamo" element={<ChiSiamoPage />} />
          <Route path="/candidature" element={<CandidaturePage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
